declare namespace $ {

	type $shm_hitalama_map_fontsize__font_size_shm_hitalama_map_widget_float_posts_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_posts['font_size'] >
		,
		ReturnType< $shm_hitalama_map_fontsize['font_size'] >
	>
	type $mol_card__content_shm_hitalama_map_widget_float_posts_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['content'] >
	>
	type $mol_view__style_shm_hitalama_map_widget_float_posts_3 = $mol_type_enforce<
		({ 
			'fontSize': ReturnType< $shm_hitalama_map_widget_float_posts['font_size_px'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_posts_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_float_posts extends $shm_hitalama_map_widget_float {
		font_size( next?: number ): number
		Font_size_tool( ): $shm_hitalama_map_fontsize
		font_size_px( ): string
		Post_dom( id: any): any
		Post( id: any): $mol_card
		posts( ): readonly(any)[]
		Posts( ): $mol_view
		tools_custom( ): readonly(any)[]
		controls( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=posts.view.tree.d.ts.map